module.exports = __webpack_public_path__ + "img/c15.665a1984.png";